module.exports = __webpack_public_path__ + "media/components/wind-icon/static/SE@2x-b405974a38d9a025f39b60df1d800210.png";